import React from 'react';
import PropTypes from 'prop-types';
import NodeActivityEditor from '../../NodeActivityEditor';
import SecondaryButton from '../../SecondaryButton';
import { PreviewSection, Questions, Question, SubmitPanel } from '../styles';
import ImmersiveReaderButton from '../../ImmersiveReaderButton';

const WrittenQuizContentPreview = ({ type, previewText, data }) => {
  const getPreviewForQuestion = (question, index) => {
    const headerRightPanel = <ImmersiveReaderButton />;
    return (
      <NodeActivityEditor
        type={type}
        index={index}
        headerText={question.body}
        headerRightPanel={headerRightPanel}
        editorText={index === 0 ? previewText : ''}
      />
    );
  };

  const questions = data.QuizQuestions.map((question, index) => (
    <Question key={question.id}>{getPreviewForQuestion(question, index)}</Question>
  ));

  return (
    <>
      <PreviewSection>
        <Questions>{questions}</Questions>
      </PreviewSection>
      <SubmitPanel className={'ir-hide'}>
        <SecondaryButton disabled={true} text={i18n.__('app_handin')} />
      </SubmitPanel>
    </>
  );
};

export default WrittenQuizContentPreview;

WrittenQuizContentPreview.propTypes = {
  type: PropTypes.string.isRequired,
  previewText: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};
